

































































































































































import { Vue, Component } from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { addClass, removeClass } from '@/utils/classUtils';
import { GetMemberGradesRequest, GetMemberGroupsRequest } from 'supporter';
import { TargetDataType } from '@/types/discount';

@Component({
  components: { CompSelectBox }
})
export default class MemberTarget extends Vue {
  private gradesContent: any = [];
  private groupsContent: any = [];
  private theGroup: any = [
    {
      no: undefined,
      content: [],
      key: 1
    }
  ];
  private theGrade: any = [
    {
      no: undefined,
      content: [],
      key: 1
    }
  ];
  private changeGrades: any = [];
  private changeGroups: any = [];
  private gradeStopAdd: boolean = false;
  private groupStopAdd: boolean = false;

  private mounted(): void {
    addClass(document.body, 'popup_small');
    this.init();
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
  }

  private init(): void {
    this.getGrades();
    this.getGroups();
  }

  private get gradeDisableStatus() {
    return !(this.theGrade[0].no || this.gradeStopAdd);
  }

  private get groupDisableStatus() {
    return !(this.theGroup[0].no || this.groupStopAdd);
  }

  private get targetType() {
    return this.$route.query.target || 'paymentTargets';
  }

  private get isUnionType() {
    return this.targetType === 'paymentTargets';
  }

  private initData(tag: string): void {
    const targetKey = this.$route.query.target || 'paymentTargets';
    const stringifiedTargetMemberInfo = $(opener.document).find(`#${targetKey}`).val() || `${this.$route.query?.data ?? ''}`;

    if (!stringifiedTargetMemberInfo) {
      return;
    }

    const targetMemberInfo: TargetDataType = JSON.parse(`${stringifiedTargetMemberInfo}`);
    if (tag === 'grades') {
      this.initSelect(targetMemberInfo['GRADE'], this.gradesContent, this.theGrade, 'changeGrades');
      this.theGrade = JSON.parse(JSON.stringify(this.theGrade));
    } else {
      this.initSelect(targetMemberInfo['GROUP'], this.groupsContent, this.theGroup, 'changeGroups');
      this.theGroup = JSON.parse(JSON.stringify(this.theGroup));
    }
  }

  private initSelect(
    data: any,
    initContent: any,
    content: any,
    changeArr: any
  ): void {
    if (data[0] === '-1') {
      return;
    }
    let _this: any = this;
    let itemContetn: any = [];
    let selectContent: any = [];
    data.map((no: any, index: any): any => {
      selectContent.push(Number(no));
      itemContetn = initContent.filter((item: any): any => {
        return selectContent.indexOf(item.no) < 0;
      });
      let lastItem: any = initContent.filter((item: any): any => {
        return item.no === selectContent[selectContent.length - 1];
      })[0];
      itemContetn.push(lastItem);
      content[index] = {};
      content[index].no = Number(no);
      if (index === 0) {
        content[index].content = initContent;
      } else {
        content[index].content = itemContetn;
        _this[changeArr] = itemContetn;
      }
    });
  }

  private handleAddGrade(
    data: any,
    changeArr: string,
    content: string,
    stop: string
  ) {
    let _this: any = this;

    if (_this[changeArr].length === 2) {
      _this[stop] = true;
    }
    if (data.content.length > 1 && _this[changeArr].length > 1) {
      let lastItem: any = _this[content][_this[content].length - 1];
      let newGrads: any = _this[changeArr].filter((item: any): any => {
        return item.no !== lastItem.no;
      });
      _this[changeArr] = [];
      _this[changeArr] = newGrads;
      let obj: any = {};
      let no: any = _this[changeArr][0].no;
      this.$set(obj, 'no', no);
      this.$set(obj, 'content', _this[changeArr]);
      _this[content].push(obj);
    }
  }

  private handleDelete(
    data: any,
    changeArr: string,
    content: string,
    initContent: string,
    stop: string
  ): void {
    let _this: any = this;
    let newArr: any = _this[content].filter((item: any): any => {
      return item.no !== data.no;
    });
    _this[content] = [];
    _this[content] = [...newArr];

    let length: any = _this[content].length;
    let deleteItem: any = _this[initContent].filter((item: any): any => {
      return item.no === data.no;
    })[0];
    let hasItem: any = _this[changeArr].filter((item: any): any => {
      return data.no === item.no;
    });
    if (hasItem.length === 0) {
      _this[changeArr].push(deleteItem);
    } else {
      let beforeNum: any = _this[content][length - 1].no;
      let beforeItem: any = _this[initContent].filter((item: any): any => {
        return item.no === beforeNum;
      })[0];
      _this[changeArr].push(beforeItem);
    }

    _this[stop] = false;
  }

  private getGrades(): void {
    let request: GetMemberGradesRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        countMember: true,
      }
    };
    this.$api.getMemberGrades(request).then((res): any => {
      this.gradesContent = [];
      this.changeGrades = [];
      let reverseData: any = res.data.reverse();
      this.gradesContent = this.formatterData(reverseData);
      this.theGrade[0].content = this.formatterData(res.data);
      this.changeGrades = this.formatterData(res.data);
      this.initData('grades');
    });
  }

  private formatterData(data: any): any {
    if (!data.length) {
      return;
    }
    let usedData: any = data.filter((item: any): any => {
      return item.used === true;
    });
    return usedData;
  }

  private getGroups(): void {
    let request: GetMemberGroupsRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
    this.$api.getMemberGroups(request).then((res): any => {
      this.groupsContent = [];
      this.changeGroups = [];
      this.groupsContent = res.data;
      this.theGroup[0].content = res.data;
      this.changeGroups = res.data;
      this.initData('groups');
    });
  }

  private save(): void {
    let data: any = this.saveData();
    if (data === 'empty') {
      alert(this.$t('MEMBER_TARGET_ALERT_TEXT'));
      return;
    }
    $(window.opener.location).attr(
      'href',
      `javascript:window.${this.$route.query.callback}(${JSON.stringify(
        data
      )});`
    );
    window.close();
  }

  private cancel(): void {
    window.close();
  }

  private saveData(): any {
    let obj: any = {};
    let grades: any = this.theGrade.map((item: any): any => {
      return item.no;
    });
    let groups: any = this.theGroup.map((item: any): any => {
      return item.no;
    });
    if (!grades[0]) {
      grades[0] = '-1';
    }
    if (!groups[0]) {
      groups[0] = '-1';
    }
    this.$set(obj, 'GRADE', grades);
    this.$set(obj, 'GROUP', groups);
    if (grades[0] === '-1' && groups[0] === '-1') {
      return 'empty';
    } else {
      return obj;
    }
  }
}
